<template>
  <div class="p-20 f-s-14">
    <!-- 主质控 -->
    <section v-if="taskType == 1">
      <section v-if="qcOrderType == 1">
        <p class="c-333 f-w-600">
          您领取到了一个
          <span class="c-red">主质控</span>
          任务，您需要完成以下职责：
        </p>
        <div class="l-h-26">1、处理并完成此任务的稿件全文质控工作；</div>
        <div class="l-h-26">2、确保频次大于等于3次的术语准确；</div>
        <div class="l-h-26">
          3、终稿无一眼可见错误（一眼可见错误是指：封面、页眉页脚、目录、标题、表头等核心位置的错译、漏译、不统一，漏段，漏页及其他的严重不可接受低级失误。）
        </div>
        <div class="l-h-26">4、输出的译稿千字综合差错率不得高于1.5‰；</div>
        <div class="l-h-26">5、遵守项目经理给出的具体项目要求；</div>
        <div class="l-h-26">6、处理子质控未完成的句子；</div>
        <div class="l-h-26">7、确保任务整体提交时，无未处理的句子数；</div>
        <div class="l-h-26">8、项目若有延期风险，提前联系PM沟通预警；</div>
        <div class="l-h-26 c-red" v-if="flowStatus === 2 && taskNum > 1">
          （本任务费用含子控任务检查以及整个项目统稿费用）
        </div>
      </section>
      <!-- MTQC主质控 -->
      <section v-else>
        <p class="c-333 f-w-600">
          您领取到了一个
          <span class="c-red">主MTQC</span>
          任务，您需要完成以下职责：
        </p>
        <div class="l-h-26">1、处理并完成此任务的稿件全文MTPE工作；</div>
        <div class="l-h-26">2、确保频次大于等于3次的术语准确；</div>
        <div class="l-h-26">
          3、终稿无一眼可见错误（一眼可见错误是指：封面、页眉页脚、目录、标题、表头等核心位置的错译、漏译、不统一，漏段，漏页及其他的严重不可接受低级失误。）
        </div>
        <div class="l-h-26">4、输出的译稿千字综合差错率不得高于1.5‰；</div>
        <div class="l-h-26">5、遵守项目经理给出的具体项目要求；</div>
        <div class="l-h-26">6、处理子MTQC未完成的句子；</div>
        <div class="l-h-26">7、确保任务整体提交时，无未处理的句子数；</div>
        <div class="l-h-26">8、项目若有延期风险，提前联系PM沟通预警；</div>
        <div class="l-h-26 c-red" v-if="flowStatus === 2 && taskNum > 1">
          （本任务费用含子控任务检查以及整个项目统稿费用）
        </div>
      </section>
    </section>
    <!-- 子质控 -->
    <section v-else>
      <section v-if="qcOrderType == 1">
        <p class="c-333 f-w-600 m-b-5">
          您领取到了一个
          <span class="c-red">子质控</span>
          任务，您需要完成以下职责：
        </p>
        <div class="l-h-26">1、处理并完成此任务的稿件质控工作；</div>
        <div class="l-h-26">2、输出的译稿千字综合差错率不得高于1.5‰；</div>
        <div class="l-h-26">3、遵守项目经理给出的具体项目要求；</div>
        <div class="l-h-26">4、确保任务整体提交时，无未处理的句子数；</div>
        <div class="l-h-26">5、项目若有延期风险，提前联系PM沟通预警；</div>
      </section>
      <!-- MTQC子质控 -->
      <section v-else>
        <p class="c-333 f-w-600 m-b-5">
          您领取到了一个
          <span class="c-red">子MTQC</span>
          任务，您需要完成以下职责：
        </p>
        <div class="l-h-26">1、处理并完成此任务的稿件全文MTPE工作；</div>
        <div class="l-h-26">2、输出的译稿千字综合差错率不得高于1.5‰；</div>
        <div class="l-h-26">3、遵守项目经理给出的具体项目要求；</div>
        <div class="l-h-26">4、确保任务整体提交时，无未处理的句子数；</div>
        <div class="l-h-26">5、项目若有延期风险，提前联系PM沟通预警；</div>
      </section>
    </section>
  </div>
</template>
<script>
import { formatDate } from '@/util/date';
export default {
  props: ['taskType', 'qcOrderType', 'flowStatus', 'taskNum'],
  data() {
    return {};
  },
};
</script>
